module.exports = __webpack_public_path__ + "static/img/chart2.691ba295.png";